import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { Route } from "@route-types/Newsletter/DecodingAsia/+types/DecodingAsiaPage";
import { fetchDecodingAsiaPageData } from "@routes/Newsletter/DecodingAsia/DecodingAsiaPage.server";
import DecodingAsiaPageContent from "@routes/Newsletter/DecodingAsia/DecodingAsiaPageContent";
import { DecodingAsiaPageContext } from "@routes/Newsletter/DecodingAsia/utils/types";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

/** This is the main entry point component for /keywords/:keyword route. */
const DecodingAsiaPage = (): React.ReactElement => {
  const context = useLoaderData<DecodingAsiaPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <DecodingAsiaPageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default DecodingAsiaPage;

export const loader = async () => await fetchDecodingAsiaPageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as DecodingAsiaPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};
